function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import GridTag from "segments/desktop/core-components/grid-tag/grid-tag";
import { MD } from "constants/sizes";
import { StyledTagsGridComponent } from "./tags-grid-component.scss";
class TagsGridComponent extends PureComponent {
    renderGridItems() {
        const { gridItems, titleSize, textSize } = this.props;
        return gridItems.map((gridItem, index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "grid-tag-component-wrapper",
                children: /*#__PURE__*/ _jsx(GridTag, _object_spread_props(_object_spread({}, gridItem), {
                    titleSize: titleSize,
                    textSize: textSize
                }))
            }, index);
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledTagsGridComponent, {
            className: "tags-grid-component",
            children: this.renderGridItems()
        });
    }
}
export { TagsGridComponent as default };
const getGridTagProps = (tagText, tagColor, fullParagraphTitle, fullParagraphBody)=>{
    const tag = _object_spread_props(_object_spread({}, GridTag.defaultProps.tag), {
        text: tagText,
        color: tagColor
    });
    const fullParagraph = _object_spread_props(_object_spread({}, GridTag.defaultProps.fullParagraph), {
        title: fullParagraphTitle,
        body: fullParagraphBody
    });
    return _object_spread_props(_object_spread({}, GridTag.defaultProps), {
        tag,
        fullParagraph
    });
};
TagsGridComponent.defaultProps = {
    gridItems: [
        getGridTagProps("Views", "pink", "Gain valuable insights", "Look at your data differently with multiple View options from Calendar to Map."),
        getGridTagProps("Automations", "green", "Turn on your autopilot", "Automate repetitive tasks and have more time for the work that motivates you."),
        getGridTagProps("Dashboards", "purple", "See the bigger picture", "Get a high-level overview at a glance and make smarter decisions, faster.")
    ],
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: MD,
    textSize: MD
};
